import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {HOTB} from "../../HOTB";
import {ExtendedGameModel} from "../../server/ExtendedGameModel";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";

export class BonusIdlePresentation implements FlowStatePresentation {
    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        const gameModel: ExtendedGameModel = HOTB.model,
            gameApi: ApiPlugin = HOTB.apiPlugin;

        gameApi.betHandler.zeroBet();

        HOTB.keypadPlugin.setZeroBetSpinCounter(gameModel.data.freespinsLeft - 1);

        flowStateController.finish();
    }
}